import { Card, Skeleton } from '@execonline-inc/execonline-ui';

function KeyMetricsSkeleton() {
  return (
    <>
      <Skeleton variant="text" className="h-5 w-16 mr-4 mb-4 mt-7" />{' '}
      <div className="w-full flex flex-wrap justify-between gap-2">
        {[...Array(3)].map((_, index) => (
          <Card
            className="grow min-w-[32%] max-w-[48%] px-3.5 py-6 sm:max-w-full"
            radius="lg"
            key={index}
          >
            <Skeleton variant="circle" className="h-4 mb-6 w-1/2" />
            <div className="flex items-center">
              <Skeleton className="h-7 w-15 mr-4" variant="circle" size="xl" />
              <Skeleton variant="text" className="h-3 w-36" />
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}

export default KeyMetricsSkeleton;
